import { useState, useRef, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { Stethoscope, Send, ShieldCheck, Lock, Eye, EyeOff, ArrowLeft, RefreshCw } from 'lucide-react';
import { authAPI } from '../../api';
import toast from 'react-hot-toast';

export default function ForgotPasswordPage() {
  const [loading, setLoading] = useState(false);
  const { register, handleSubmit, formState: { errors } } = useForm();
  const navigate = useNavigate();

  const handleEmailSubmit = async (data) => {
    setLoading(true);
    try {
      await authAPI.forgotPassword({ email: data.email });
      toast.success('Temporary password sent to your email');
      setTimeout(() => navigate('/login'), 2000);
    } catch (err: any) {
      console.error("Forgot password error:", err);
      toast.error(err.response?.data?.message || 'Failed to send reset code');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-bg" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px', minHeight: '100vh', background: 'linear-gradient(135deg, #f0fdfa 0%, #e0f2fe 40%, #faf5ff 80%, #fff7ed 100%)' }}>
      <div style={{ width: '100%', maxWidth: '440px', animation: 'fadeIn 0.5s ease-out' }}>
        {/* Brand */}
        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          <div style={{
            width: '64px', height: '64px', borderRadius: '18px',
            background: 'linear-gradient(135deg, #14b8a6, #0d9488)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            margin: '0 auto 16px', boxShadow: '0 12px 32px rgba(20,184,166,0.3)',
            border: '2px solid rgba(255,255,255,0.6)'
          }}>
            <Stethoscope size={30} color="white" />
          </div>
          <h1 style={{ color: '#0f172a', fontSize: '28px', fontWeight: '800', letterSpacing: '-0.5px' }}>
            Decso<span style={{ color: '#14b8a6' }}>plus</span>
          </h1>
        </div>

        {/* Card */}
        <div className="auth-card" style={{
            background: 'rgba(255,255,255,0.9)', backdropFilter: 'blur(10px)',
            borderRadius: '24px', padding: '40px',
            boxShadow: '0 20px 40px rgba(0,0,0,0.08)',
            border: '1px solid rgba(255,255,255,0.6)',
            position: 'relative', overflow: 'hidden'
        }}>
          <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: '4px', background: 'linear-gradient(90deg, #14b8a6, #0d9488)' }} />

              <h2 style={{ fontSize: '24px', fontWeight: '800', color: '#0f172a', marginBottom: '8px' }}>Forgot Password?</h2>
              <p style={{ fontSize: '14px', color: '#64748b', marginBottom: '32px' }}>Enter your email and we'll send you a temporary password.</p>

              <form onSubmit={handleSubmit(handleEmailSubmit)} style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                <div>
                  <label className="form-label">Email Address</label>
                  <input
                    type="email"
                    className="form-input"
                    placeholder="seller@store.com"
                    style={{ height: '48px' }}
                    {...register('email', { required: 'Email is required', pattern: { value: /^\S+@\S+$/i, message: 'Invalid email' } })}
                  />
                  {errors.email && <p style={{ color: '#ef4444', fontSize: '12px', marginTop: '6px' }}>{errors.email.message as string}</p>}
                </div>

                <button type="submit" className="btn-primary" style={{ width: '100%', justifyContent: 'center', height: '52px', fontSize: '16px', borderRadius: '12px' }} disabled={loading}>
                  {loading ? <div className="spinner" style={{ width: '20px', height: '20px' }} /> : <><Send size={18} /> Send Temporary Password</>}
                </button>
              </form>

          <div style={{ textAlign: 'center', marginTop: '32px' }}>
            <Link to="/login" style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', color: '#14b8a6', fontSize: '14px', fontWeight: '700', textDecoration: 'none' }}>
              <ArrowLeft size={16} /> Back to Sign In
            </Link>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes fadeIn { from { opacity: 0; transform: translateY(12px); } to { opacity: 1; transform: translateY(0); } }
        .spin { animation: spin 1s linear infinite; }
        @keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
      `}</style>
    </div>
  );
}
